import LogoLoader from 'components/_common/LogoLoader';
import { t } from 'i18next';
import 'modules/admin/assets/scss/systemStatusPage.scss';

export default function NoInternet() {
  return (
    <div className="system-status-page d-flex flex-column align-items-center justify-content-center vh-100 text-center px-3">
      <LogoLoader
        background="dark"
        overlay={false}
        fullscreen={false}
        messages={[t('offline_message_1'), t('offline_message_2')]}
      />
      <h3 className="system-status-page__title mt-3 mb-2">{t('offline_title')}</h3>
      <p className="system-status-page__text mb-0">{t('offline_subtitle')}</p>
      <p className="system-status-page__text">{t('offline_resume_note')}</p>
    </div>
  );
}
